import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { MappedPassengerType } from '../../types';

interface useSearchesInterface {
  passengers: MappedPassengerType[]
}

export default function useSearches({ passengers }: useSearchesInterface) {
  const [filteredPassengers, setFilteredPassengers] = useState<MappedPassengerType[]>([]);

  const [searchNameTerm, setSearchNameTerm] = useState('');
  const [searchCpfTerm, setSearchCpfTerm] = useState('');
  const [searchConsultTerm, setSearchConsultTerm] = useState('');
  const [selectedGoingLine, setSelectedGoingLine] = useState({ value: '', label: 'Selecione uma linha'});
  const [selectedBackLine, setSelectedBackLine] = useState({ value: '', label: 'Selecione uma linha'});
  const [selectedStatus, setSelectedStatus] = useState({ value: '', label: 'Todos'});

  const filterPassengers = useCallback(() => {
    const filteredPassengers = passengers?.filter((psg) => {
      const nameFilter = psg?.name?.toLowerCase().startsWith(searchNameTerm.toLowerCase());
      const consultCodeFilter = String(psg?.consultCode)?.startsWith(searchConsultTerm.toLowerCase());
      const cpfFilter = psg?.cpf?.toLowerCase().replaceAll('.', '').replaceAll('-', '').startsWith(searchCpfTerm.toLowerCase());
      const goingLineFilter = !selectedGoingLine.value || psg.goingLineRouteId === selectedGoingLine.value;
      const backLineFilter = !selectedBackLine.value || psg.backLineRouteId === selectedBackLine.value;
      const statusFilter = !selectedStatus.value || psg.status === selectedStatus.value;

      return nameFilter && consultCodeFilter && cpfFilter && statusFilter && goingLineFilter && backLineFilter;
    });

    setFilteredPassengers(filteredPassengers);
  }, [passengers, searchNameTerm, searchConsultTerm, searchCpfTerm, selectedGoingLine.value, selectedBackLine.value, selectedStatus]);

  useEffect(() => {
    filterPassengers();
  }, [filterPassengers]);

  function handleChangeSearchNameTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchNameTerm(event.target.value);
  }

  function handleChangeSearchCpfTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchCpfTerm(event.target.value);
  }

  function handleChangeSearchConsultTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchConsultTerm(event.target.value);
  }

  function handleChangeSelectedGoingLine(goingLine: { value: string, label: string }) {
    setSelectedGoingLine(goingLine);
  }

  function handleChangeSelectedBackLine(backLine: { value: string, label: string }) {
    setSelectedBackLine(backLine);
  }

  function handleChangeSelectedStatus(status: { value: string, label: string }) {
    setSelectedStatus(status);
  }

  return {
    filteredPassengers,
    handleChangeSearchNameTerm,
    handleChangeSearchCpfTerm,
    handleChangeSearchConsultTerm,
    handleChangeSelectedGoingLine,
    handleChangeSelectedBackLine,
    handleChangeSelectedStatus,
    searchCpfTerm,
    searchNameTerm,
    searchConsultTerm,
    selectedGoingLine,
    selectedBackLine,
    selectedStatus,
  };
}
